import React from 'react';
import MakeupAnalysisScreen from '../screens/MakeupAnalysisScreen';

export default function MakeupAnalysisPage(): React.JSX.Element {
  return <MakeupAnalysisScreen mode="page" />;
}
